var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$bus.toast.show),expression:"$bus.toast.show"}],staticClass:"mask",class:_vm.getClass,on:{"click":_vm.hide}},[_c('div',{ref:"toast",staticClass:"toast"},[_vm._v(_vm._s(_vm.$bus.toast.content))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-886cb3b4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/toast/index.vue
// module id = null
// module chunks = 